import React from "react";

const MessageListShimmer = () => {
  return (
    <div className="md:w-9/12 h-dvh py-8 px-3 flex flex-col justify-end ">
      <div className="flex my-1.5 justify-end">
        <div className="h-10 w-3/12 bg-gray-300 animate-pulse rounded-lg"></div>
      </div>
      <div className="flex my-1.5 justify-end">
        <div className="h-20 w-8/12 bg-gray-300 animate-pulse rounded-lg"></div>
      </div>
      <div className="flex my-1.5 justify-normal">
        <div className="h-10 w-3/12 bg-gray-300 animate-pulse rounded-lg"></div>
      </div>
      <div className="flex my-1.5 justify-normal">
        <div className="h-20 w-8/12 bg-gray-300 animate-pulse rounded-lg"></div>
      </div>
      <div className="flex my-1.5 justify-end">
        <div className="h-10 w-3/12 bg-gray-300 animate-pulse rounded-lg"></div>
      </div>
      <div className="flex my-1.5 justify-end">
        <div className="h-20 w-8/12 bg-gray-300 animate-pulse rounded-lg"></div>
      </div>
    </div>
  );
};

export default MessageListShimmer;
